import styled from 'styled-components';

export const Wrapper = styled.main`
  margin-left: ${(props) => (props.isOpen ? '12rem' : '0')};
  transition: 0.3s ease-in-out;
`;
